var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('van-popup', {
    staticClass: "wechat-popup text-center",
    attrs: {
      "round": "",
      "closeable": ""
    },
    on: {
      "click-overlay": _vm.close,
      "close": _vm.close,
      "click-close-icon": _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "wechat-popup-title text-huge font-bold"
  }, [_c('van-icon', {
    attrs: {
      "name": "checked"
    }
  }), _vm._v(" 保存成功 ")], 1), _c('div', {
    staticClass: "text-large font-bold mt-20"
  }, [_vm._v("扫码添加【百日跑小助理】")]), _c('div', {
    staticClass: "wechat-popup-desc text-small font-bold"
  }, [_vm._v("多款好礼[免费抽]")]), _c('div', {
    staticClass: "wechat-popup-desc text-small font-bold"
  }, [_vm._v("还有阳光普照奖哦")]), _c('div', {
    staticClass: "text-large font-bold mt-10 mb-10"
  }, [_vm._v("长按图片添加专属客服")]), _c('img', {
    staticClass: "wechat-popup-code",
    attrs: {
      "src": _vm.enterCode,
      "alt": ""
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };